import { z } from 'zod';
import * as glossaireAffichage from '../../ressources/glossaires/glossaire_affichage_type_capteur';

/**
 * Valeurs d'affichage autorisées, dérivées du glossaire plutôt que recopiées.
 *
 * Le même glossaire alimente les options du <select> dans les deux écrans : le
 * schéma et la liste proposée ne peuvent donc pas diverger, et ajouter une
 * valeur au glossaire suffit à la rendre valide ici.
 */
const valeursAffichage = Object.values(glossaireAffichage);

/**
 * Schéma de la charge utile envoyée à la création d'un type de capteur.
 *
 * Les deux écrans concernés ne construisent pas la charge utile eux-mêmes : ils
 * transmettent des arguments positionnels à une action Redux qui l'assemble.
 * Le schéma décrit ce que cette action envoie, et la validation reste dans le
 * composant, là où les messages s'affichent.
 */
export const schemaNouveauTypeDeCapteur = z.object({
  sensor_type_name: z
    .string({ message: 'saisir_un_nom_de_type_de_capteur' })
    .trim()
    .min(1, { message: 'saisir_un_nom_de_type_de_capteur' }),

  sensor_type_display: z.enum(valeursAffichage, { message: 'valeur_invalide' }),
});

/**
 * Schéma de la charge utile envoyée à la modification d'un type de capteur.
 * Même contrat, plus l'identifiant du type visé.
 */
export const schemaModificationTypeDeCapteur =
  schemaNouveauTypeDeCapteur.extend({
    sensor_type_id: z.coerce.number({ message: 'valeur_invalide' }).int(),
  });
